import React from 'react';

import ImageUpload from "../../../components/CustomUpload/ImageUpload.js";

import { makeStyles } from "@material-ui/core/styles";

const styles = {
  leyenda: {
  fontSize: "1em"
  }
};
const useStyles = makeStyles(styles);

export default function Imagen({ title = "", onChange = (evt) => console.log(evt), avatar, removeImage, value, disabled, sizeMax = null }) {

    let newProps = {};
    if(avatar) newProps = { avatar: true };
    newProps = { tamañoMax: sizeMax };
    const classes = useStyles();

    return (<div id="img upload" style={{ textAlign: "center", width:"100%" }}>
        <legend className={classes.leyenda}>{title}</legend>
        <ImageUpload
            { ...newProps }
            removeImage={removeImage}
            onChange={onChange}
            value={value}
            disabled={disabled}
            addButtonProps={{
                color: "rose",
                round: true
            }}
            changeButtonProps={{
                color: "rose",
                round: true
            }}
            removeButtonProps={{
                color: "tumblr",
                round: true
            }}
        />
    </div>);

}
